module.exports = __webpack_public_path__ + "static/media/22-8.35ff374b.mp3";